'use client';

import { MarketType } from '@velocity-exchange/sdk';
import { getMaxLeverageForMarket } from '@velocity-exchange/common';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityClientIsReady from './useVelocityClientIsReady';

const DEFAULT_STATE = {
	maxLeverage: 0,
};

const useMarketMaxLeverage = (
	marketType: MarketType,
	marketIndex: number | undefined
) => {
	const velocityClient = useVelocityStore((s) => s.velocityClient.client);
	const velocityClientIsReady = useVelocityClientIsReady();

	if (
		!velocityClientIsReady ||
		!velocityClient ||
		!velocityClient.isSubscribed ||
		marketIndex === undefined
	) {
		return DEFAULT_STATE;
	}

	const { maxLeverage } = getMaxLeverageForMarket(
		marketType,
		marketIndex,
		velocityClient
	);

	return {
		maxLeverage,
	};
};

export default useMarketMaxLeverage;
